import React from 'react';
import { Check } from 'lucide-react';
export function Services() {
  const acquisitionList = ['Business model analysis', 'License and activity review', 'Location and rent evaluation', 'Financial health check', 'Operational risks', 'Equipment and asset review', 'Staff and service structure', 'Negotiation strategy', 'ROI and break-even estimation'];
  const setupList = ['Concept development', 'Brand positioning', 'Service menu structure', 'Financial model', 'Investment budget', 'CAPEX and OPEX planning', 'Location search support', 'Team structure', 'Launch strategy', 'Sales funnel and marketing roadmap', 'Operational checklist'];
  return <section id="services" className="py-24 bg-white" data-id="element-162">
      <div className="max-w-7xl mx-auto px-6" data-id="element-163">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-164">
          <h2 className="text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-165">
            What We Help With
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-166">
            Expert Guidance at Every Step
          </h3>
          <p className="text-charcoal-light text-lg font-light leading-relaxed" data-id="element-167">
            Whether you are looking to purchase an existing salon, aesthetic
            clinic, beauty center, spa or launch a new concept from scratch, we
            support you with business evaluation, market positioning, financial
            planning and operational setup.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-16" data-id="element-168">
          {/* Acquisition Card */}
          <div className="bg-cream p-8 md:p-12 border border-charcoal/5" data-id="element-169">
            <h4 className="text-3xl font-serif mb-4" data-id="element-170">
              Business Acquisition Support
            </h4>
            <p className="text-charcoal-light mb-8 font-light leading-relaxed" data-id="element-171">
              We help you review and evaluate existing beauty businesses for
              sale in Dubai. Our goal is to help you understand whether the
              business is worth buying before you invest.
            </p>
            <ul className="space-y-4" data-id="element-172">
              {acquisitionList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-173">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-174" />
                  <span className="text-sm md:text-base" data-id="element-175">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Setup Card */}
          <div className="bg-charcoal text-cream p-8 md:p-12" data-id="element-176">
            <h4 className="text-3xl font-serif mb-4" data-id="element-177">
              Turnkey Beauty Business Setup
            </h4>
            <p className="text-cream-dark mb-8 font-light leading-relaxed" data-id="element-178">
              For those who want to open a new beauty business in Dubai, we help
              structure the full launch plan from idea to opening. You receive a
              clear plan to profitability.
            </p>
            <ul className="space-y-4" data-id="element-179">
              {setupList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-180">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-sm md:text-base text-cream-dark" data-id="element-182">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}